export default "__VITE_ASSET__BKbT7eud__"